import { createSelector } from "@reduxjs/toolkit";
export var selectIframeState = function (state) { return state.iframe; };
export var currentIframeId = createSelector(selectIframeState, function (iframe) { return iframe === null || iframe === void 0 ? void 0 : iframe.id; });
export var selectIframeViewProps = createSelector(selectIframeState, function (iframe) { return iframe.viewProps; });
export var selectIframeViewConfig = createSelector(selectIframeState, function (iframe) { return iframe.viewConfig; });
